import { render } from "./CoohomeView.vue?vue&type=template&id=019e42fb"
import script from "./CoohomeView.vue?vue&type=script&lang=js"
export * from "./CoohomeView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/john/Desktop/projects/vue_js_projects/portfolio-tailwind/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__